var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIosButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 218.661,
    height: 62.951,
    viewBox: "0 0 218.661 62.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 218.661,
    height: 62.951,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M212.536,1.5h.37a6.517,6.517,0,0,1,6.515,6.515V57.2a6.517,6.517,0,0,1-6.515,6.515H8.015A6.517,6.517,0,0,1,1.5,57.2V8.015A6.517,6.517,0,0,1,8.015,1.5Z",
    transform: "translate(-1.13 -1.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M212.536,1.5h.37a6.517,6.517,0,0,1,6.515,6.515V57.2a6.517,6.517,0,0,1-6.515,6.515H8.015A6.517,6.517,0,0,1,1.5,57.2V8.015A6.517,6.517,0,0,1,8.015,1.5Z",
    transform: "translate(-1.13 -1.13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M105.717,88.049a9.128,9.128,0,0,1,4.392-7.724,9.455,9.455,0,0,0-7.428-4.022c-3.134-.321-6.169,1.875-7.749,1.875s-4.072-1.826-6.712-1.777A9.823,9.823,0,0,0,79.88,81.46c-3.6,6.243-.913,15.4,2.542,20.457,1.727,2.468,3.751,5.232,6.391,5.133,2.591-.1,3.553-1.653,6.663-1.653s4,1.653,6.687,1.579c2.764-.049,4.516-2.468,6.194-4.96a20.822,20.822,0,0,0,2.838-5.75,8.951,8.951,0,0,1-5.478-8.217",
    transform: "translate(-58.88 -57.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M150.676,43.19a9.035,9.035,0,0,0,2.073-6.49,9.3,9.3,0,0,0-5.972,3.085,8.63,8.63,0,0,0-2.122,6.268,7.746,7.746,0,0,0,6.021-2.863",
    transform: "translate(-108.923 -27.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M272.391,127.113h-8.464l-2.023,6.021h-3.6l8.02-22.234h3.726l8.02,22.234h-3.652Zm-7.6-2.764H271.5L268.2,114.6h-.074Z",
    transform: "translate(-194.56 -83.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M362.175,142.892c0,5.034-2.69,8.267-6.762,8.267a5.507,5.507,0,0,1-5.108-2.838h-.074v8.045H346.9V134.773h3.233v2.69h.049a5.785,5.785,0,0,1,5.182-2.863c4.1,0,6.811,3.257,6.811,8.292m-3.43,0c0-3.282-1.7-5.429-4.294-5.429-2.542,0-4.244,2.2-4.244,5.429s1.7,5.454,4.244,5.454c2.591,0,4.294-2.147,4.294-5.454",
    transform: "translate(-261.296 -101.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M434.475,142.892c0,5.034-2.69,8.267-6.761,8.267a5.507,5.507,0,0,1-5.108-2.838h-.074v8.045H419.2V134.773h3.233v2.69h.049a5.725,5.725,0,0,1,5.157-2.863c4.121,0,6.835,3.257,6.835,8.292m-3.43,0c0-3.282-1.7-5.429-4.294-5.429-2.542,0-4.244,2.2-4.244,5.429s1.7,5.454,4.244,5.454c2.591,0,4.294-2.147,4.294-5.454",
    transform: "translate(-315.755 -101.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M518.43,125.81c.247,2.2,2.394,3.652,5.306,3.652,2.813,0,4.812-1.456,4.812-3.43,0-1.727-1.209-2.764-4.1-3.479l-2.887-.691c-4.071-.987-5.972-2.887-5.972-6,0-3.85,3.356-6.465,8.094-6.465,4.713,0,7.921,2.64,8.02,6.465H528.35c-.2-2.221-2.024-3.554-4.713-3.554s-4.516,1.357-4.516,3.331c0,1.579,1.184,2.492,4.047,3.208l2.443.592c4.565,1.086,6.465,2.912,6.465,6.169,0,4.17-3.307,6.762-8.587,6.762-4.935,0-8.267-2.542-8.489-6.564Z",
    transform: "translate(-387.915 -82.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M595.825,119.8v3.85h3.085v2.616h-3.085V135.2c0,1.382.617,2.024,1.974,2.024a7.758,7.758,0,0,0,1.086-.074v2.616a7.814,7.814,0,0,1-1.851.148c-3.282,0-4.565-1.234-4.565-4.368v-9.279H590.1v-2.64h2.369V119.8Z",
    transform: "translate(-444.483 -90.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M633.1,142.816c0-5.108,3.01-8.316,7.7-8.316s7.7,3.208,7.7,8.316-2.986,8.316-7.7,8.316-7.7-3.208-7.7-8.316m11.993,0c0-3.5-1.6-5.577-4.294-5.577s-4.294,2.073-4.294,5.577,1.6,5.577,4.294,5.577,4.294-2.073,4.294-5.577",
    transform: "translate(-476.872 -101.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M706.425,134.773h3.184v2.764h.074a3.9,3.9,0,0,1,3.9-2.937,5.713,5.713,0,0,1,1.135.123v3.109a4.434,4.434,0,0,0-1.505-.2c-2.147,0-3.479,1.456-3.479,3.726v9.624H706.4V134.773Z",
    transform: "translate(-532.083 -101.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M757.633,146.072c-.444,2.937-3.307,4.96-6.983,4.96-4.713,0-7.65-3.159-7.65-8.242s2.937-8.39,7.5-8.39c4.491,0,7.3,3.085,7.3,8v1.135h-11.45v.2a4.233,4.233,0,0,0,4.368,4.59,3.694,3.694,0,0,0,3.751-2.27Zm-11.253-4.837H754.5a3.9,3.9,0,0,0-3.973-4.121,4.131,4.131,0,0,0-4.146,4.121",
    transform: "translate(-559.652 -101.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M271.15,43c3.183,0,5.034,1.949,5.034,5.306,0,3.405-1.851,5.38-5.034,5.38H267.3V43Zm-2.2,9.18h2.024c2.246,0,3.529-1.382,3.529-3.85,0-2.418-1.308-3.825-3.529-3.825h-2.024Z",
    transform: "translate(-201.339 -32.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M310.9,57.2c0-2.591,1.456-4.2,3.8-4.2s3.8,1.579,3.8,4.2-1.456,4.2-3.8,4.2-3.8-1.579-3.8-4.2m5.972,0c0-1.752-.79-2.764-2.172-2.764s-2.172,1.012-2.172,2.764.79,2.764,2.172,2.764,2.172-1.012,2.172-2.764",
    transform: "translate(-234.18 -39.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M355.358,61.669H353.7l-1.678-5.947H351.9l-1.653,5.947h-1.629L346.4,53.6H348l1.456,6.169h.123l1.653-6.169h1.53l1.653,6.169h.123l1.431-6.169h1.6Z",
    transform: "translate(-260.92 -40.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M399.225,53.148h1.53v1.283h.123A2.423,2.423,0,0,1,403.3,53c1.8,0,2.788,1.086,2.788,3.011v5.232h-1.6V56.405c0-1.283-.567-1.949-1.752-1.949A1.849,1.849,0,0,0,400.8,56.5v4.713h-1.6V53.148Z",
    transform: "translate(-300.69 -39.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 1.604,
    height: 11.203,
    transform: "translate(107.911 10.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M452.7,57.2c0-2.591,1.456-4.2,3.8-4.2s3.8,1.579,3.8,4.2-1.456,4.2-3.8,4.2-3.8-1.579-3.8-4.2m5.972,0c0-1.752-.79-2.764-2.171-2.764s-2.172,1.012-2.172,2.764.765,2.764,2.172,2.764,2.171-1.012,2.171-2.764",
    transform: "translate(-340.988 -39.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M490.3,58.947c0-1.456,1.086-2.295,3.011-2.418l2.171-.123v-.691c0-.839-.568-1.333-1.653-1.333-.888,0-1.505.321-1.678.888h-1.53c.173-1.382,1.456-2.27,3.282-2.27,2.024,0,3.159,1.012,3.159,2.714v5.5h-1.53V60.082h-.123a2.7,2.7,0,0,1-2.418,1.259,2.418,2.418,0,0,1-2.69-2.394m5.182-.691V57.59l-1.974.123c-1.11.074-1.6.444-1.6,1.16s.617,1.16,1.505,1.16a1.884,1.884,0,0,0,2.073-1.777",
    transform: "translate(-369.31 -39.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M526.3,48.006c0-2.542,1.308-4.17,3.356-4.17a2.645,2.645,0,0,1,2.468,1.407h.124V40.8h1.6V52h-1.53V50.72H532.2a2.779,2.779,0,0,1-2.542,1.407c-2.073.049-3.356-1.579-3.356-4.121m1.629,0c0,1.7.814,2.739,2.147,2.739s2.172-1.036,2.172-2.739-.839-2.739-2.172-2.739-2.147,1.036-2.147,2.739",
    transform: "translate(-396.426 -30.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M583.5,57.2c0-2.591,1.456-4.2,3.8-4.2s3.8,1.579,3.8,4.2-1.431,4.2-3.8,4.2-3.8-1.579-3.8-4.2m5.972,0c0-1.752-.79-2.764-2.172-2.764s-2.172,1.012-2.172,2.764.79,2.764,2.172,2.764,2.172-1.012,2.172-2.764",
    transform: "translate(-439.511 -39.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M623,53.148h1.53v1.283h.123A2.423,2.423,0,0,1,627.072,53c1.8,0,2.788,1.086,2.788,3.011v5.232h-1.6V56.405c0-1.283-.567-1.949-1.727-1.949A1.862,1.862,0,0,0,624.6,56.5v4.713H623Z",
    transform: "translate(-469.264 -39.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M678.463,45.5v2.048h1.752v1.333h-1.752v4.146c0,.839.345,1.209,1.135,1.209a5.641,5.641,0,0,0,.617-.049v1.333a5.1,5.1,0,0,1-.864.074c-1.777,0-2.468-.617-2.468-2.172V48.881H675.6V47.548h1.283V45.5Z",
    transform: "translate(-508.884 -34.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M703.025,40.9H704.6v4.442h.123a2.459,2.459,0,0,1,2.468-1.431c1.728,0,2.764,1.086,2.764,3.011v5.207h-1.6V47.291c0-1.283-.592-1.949-1.728-1.949A1.874,1.874,0,0,0,704.6,47.39V52.1H703V40.9Z",
    transform: "translate(-529.522 -30.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M746.73,59.046a3.29,3.29,0,0,1-3.5,2.32c-2.319,0-3.726-1.579-3.726-4.17s1.456-4.2,3.726-4.2,3.6,1.53,3.6,4.072v.543h-5.7v.1a2.136,2.136,0,0,0,2.147,2.32,1.931,1.931,0,0,0,1.925-.987Zm-5.6-2.591H745.2a1.966,1.966,0,0,0-1.974-2.1,2.094,2.094,0,0,0-2.1,2.1",
    transform: "translate(-557.016 -39.921)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosButton);
export default __webpack_public_path__ + "static/media/iosButton.f027c1b0abca411114d387549c41d3e2.svg";
export { ForwardRef as ReactComponent };